import { BRAND, NAV_LINKS, waLink } from "@/content";

export const Header = () => (
  <>
    <div className="topline" data-testid="topline">
      {BRAND.topline}
    </div>
    <header className="site-header">
      <div className="wrap nav">
        <a className="brand" href="#inicio" data-testid="brand-link">
          {BRAND.name}
          <small>{BRAND.tagline}</small>
        </a>
        <nav className="main-nav" aria-label="Navegação principal">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.slice(1)}`}
            >
              {link.label}
            </a>
          ))}
        </nav>
        <a
          className="btn"
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-cta-agendar"
        >
          Agendar conversa
        </a>
      </div>
    </header>
  </>
);
